import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div
                className="h-screen w-screen flex items-center justify-center text-sm text-muted-foreground"
                data-testid="auth-loading"
            >
                Booting console…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "ADMIN") return <Navigate to="/" replace />;
    return children;
}
